import doXtractAPI from './xtractAPISagas'
import { fork } from 'redux-saga/effects'

export function* handleSequentialRequest() {
  return yield* doXtractAPI.apply(this, arguments)
}

export function* handleParallelRequest() {
  return yield fork(doXtractAPI, ...arguments)
}
